import { AutogenLayoutBreakthroughFuelReady } from "./autogen/AutogenLayoutBreakthroughFuelReady";
import {  DataSourceExecutionEvent, MultiButton, TableRow, TableSelectionEvent } from "@mcleod/components";
import { Currency } from "@mcleod/core";
import { BreakthroughFuelUtility } from "./BreakthroughFuelUtility";
import { Action, ProcessingHandler, ProcessingStepper } from "@mcleod/integrations";
import { CommonDialogs } from "@mcleod/common";

export class BreakthroughFuelReady extends AutogenLayoutBreakthroughFuelReady {
    private _selectedRows: TableRow[];
    private _refreshTabsCallback?: () => void;
    private processingHandler: ProcessingHandler;

    get selectedRows(): TableRow[] {
        return this._selectedRows;
    }

    set selectedRows(value: TableRow[]) {
        this._selectedRows = value;
    }

    set refreshTabsCallback(cb: () => void) {
        this._refreshTabsCallback = cb;
    }

    get refreshTabsCallback(): (() => void) | undefined {
        return this._refreshTabsCallback;
    }

    override onLoad () {
        this.processingHandler = new ProcessingHandler({ title: "Breakthrough Fuel", endpoint: "lme/ar/post-breakthrough-fuel" }, this.tableBreakthrough);
        this.processingHandler.multiButton.primaryButton.disabledTooltip = "Select Breakthrough Fuel record(s) to enable posting options";
        this.processingHandler.buttonPostOnClick = this.processingActionOnPost.bind(this);
        this.tableBreakthrough.addSelectionListener(this.onTableSelection.bind(this));
    }

    processingActionOnPost(action: Action) {
        this.processingHandler.showSlideout({
            title: `Process Breakthrough Fuel (${this.tableBreakthrough.selectedRows?.length}) Records`,
            doAfterSlideIn: async (decorator) => {
                const stepper = decorator.layout as ProcessingStepper;
                stepper.calculatePostableTotals = this.getTotalSelectedFuelSurcharge.bind(this);
                stepper.doAfterPost = () => this.doAfterBreakthroughFuelPost.bind(this);
                stepper.getApiPayload = (posting: boolean) => ({
                    selected_ids: this.getSelectedIds(),
                    print_edit_list: !posting,
                    is_posting: posting
                });
                switch (action) {
                    case Action.POST:
                        stepper.continue();
                        break;
                    case Action.PRINT_AND_POST:
                        stepper.displayReport();
                        break;
                }
            }
        });
    }


    /** This is an event handler for the beforeExecution event of sourceBreakthroughTransaction. */
    sourceBreakthroughTransactionBeforeExecution(event: DataSourceExecutionEvent) {
        event.filter.on_hold = "N";
    }

    getTotalSelectedFuelSurcharge() {
        const totalSelectedFuelCharge = new Currency(0);
        this.tableBreakthrough.selectedRows.forEach(async row => {
            await totalSelectedFuelCharge.add(row.data.getCurrency("fuel_surcharge"));
            await totalSelectedFuelCharge.add(row.data.getCurrency("reefer_surcharge"));
        });
        return { count: this.tableBreakthrough.selectedRowCount, amount: new Currency(totalSelectedFuelCharge) };
    }


    public getSelectedIds(): string[] {
        return this.tableBreakthrough.selectedRows.map(row => row.data.get("id") as string);
    }

    public refreshTabData() {
        this.refreshTabsCallback?.();
    }

    /**
     * Handles table selection events
     */
    onTableSelection(event: TableSelectionEvent) {
        const tableRow = event?.newRow;
        this.selectedRows = tableRow?.table?.selectedRows;

        const hasSelectedRows = this.selectedRows?.length > 0;
        this.processingHandler.multiButton.enabled = hasSelectedRows;
    }

    /** This is an event handler for the onClick event of buttonDownload. */
    async buttonDownloadOnClick() {
        await BreakthroughFuelUtility.downloadBreakthroughFuelTransactions(this.buttonDownload, this.refreshTabsCallback);
    }

    async doAfterBreakthroughFuelPost(response) {
        const responseFirstRow = response?.data?.[0];
        const errorMsg = response?.error?.message || responseFirstRow?.error;
        if (errorMsg) {
            await CommonDialogs.showMessage(errorMsg, "Error");
            return;
        }
        this.refreshTabData();
    }

}
